import { createRouter, createWebHistory } from "vue-router";
import store from "../store";
import Home from "../views/Home.vue";

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
    meta: {
      transition: "fade-in-down",
      title: "Relsify - Blockchain-based Real Estate Platform",
    },
  },
  {
    path: "/about",
    name: "About",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/About.vue"),
    meta: {
      transition: "fade-in-down",
      title: "Relsify - About",
    },
  },
  {
    path: "/contact",
    name: "Contact",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Contact.vue"),
    meta: {
      transition: "fade-in-down",
      title: "Relsify - Contact",
    },
  },
  {
    path: "/explore-marketplace",
    name: "ExploreMarketPlace",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/ExploreMarketPlace.vue"),
    meta: {
      transition: "fade-in-down",
      title: "Relsify - Explore market place",
    },
  },
  {
    path: "/tokenize-property",
    name: "TokenizeProperty",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/TokenizeProperty.vue"),
    meta: {
      transition: "fade-in-down",
      title: "Relsify - Tokenize your property",
    },
  },
  {
    path: "/tokenize-property/form",
    name: "TokenizePropertyForm",
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../views/TokenizePropertyForm.vue"
      ),
    meta: {
      transition: "fade-in-down",
      title: "Relsify - Tokenize your property",
    },
  },
  {
    path: "/project/details",
    name: "ProjectDetails",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/ProjectDetails.vue"),
    meta: {
      transition: "fade-in-down",
      title: "Relsify - Project details",
    },
  },
  {
    path: "/terms-and-condition",
    name: "TermsAndConditions",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/TermsAndConditions.vue"),
    meta: {
      transition: "fade-in-down",
      title: "Relsify - Terms and conditions",
    },
  },
  {
    path: "/blog",
    name: "Blog",
    component: () => import(/* webpackChunkName: "Blog" */ "../views/Blog.vue"),
    meta: {
      transition: "fade-in-down",
      title: "Relsify - Blog",
    },
  },
  {
    path: "/careers",
    name: "Careers",
    component: () =>
      import(/* webpackChunkName: "careers" */ "../views/Careers.vue"),
    meta: {
      transition: "fade-in-down",
      title: "Relsify - Careers",
    },
  },
  {
    path: "/faq",
    name: "FAQ",
    component: () => import(/* webpackChunkName: "about" */ "../views/FAQ.vue"),
    meta: {
      transition: "fade-in-down",
      title: "Relsify - FAQ",
    },
  },
  {
    path: "/faq/category",
    name: "FAQFilter",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/FAQFilter.vue"),
    meta: {
      transition: "fade-in-down",
      title: "Relsify - FAQFilter",
    },
  },
  {
    path: "/help-center",
    name: "HelpCenter",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/HelpCenter.vue"),
    meta: {
      transition: "fade-in-down",
      title: "Relsify - Help center",
    },
  },
];

const router = createRouter({
  // history: createWebHistory(process.env.BASE_URL),
  history: createWebHistory(),
  routes,
  scrollBehavior() {
    document.getElementById("app").scrollIntoView();
  },
});

router.beforeEach((to, from, next) => {
  store.dispatch("closeMobileMenu");
  next();
});

// This callback runs before every route change, including on page load.
router.beforeEach((to, from, next) => {
  // This goes through the matched routes from last to first, finding the closest route with a title.
  // e.g., if we have `/some/deep/nested/route` and `/some`, `/deep`, and `/nested` have titles,
  // `/nested`'s will be chosen.
  const nearestWithTitle = to.matched
    .slice()
    .reverse()
    .find((r) => r.meta && r.meta.title);

  // Find the nearest route element with meta tags.
  const nearestWithMeta = to.matched
    .slice()
    .reverse()
    .find((r) => r.meta && r.meta.metaTags);

  const previousNearestWithMeta = from.matched
    .slice()
    .reverse()
    .find((r) => r.meta && r.meta.metaTags);

  // If a route with a title was found, set the document (page) title to that value.
  if (nearestWithTitle) {
    document.title = nearestWithTitle.meta.title;
  } else if (previousNearestWithMeta) {
    document.title = previousNearestWithMeta.meta.title;
  }

  // Remove any stale meta tags from the document using the key attribute we set below.
  Array.from(document.querySelectorAll("[data-vue-router-controlled]")).map(
    (el) => el.parentNode.removeChild(el)
  );

  // Skip rendering meta tags if there are none.
  if (!nearestWithMeta) return next();

  // Turn the meta tag definitions into actual elements in the head.
  nearestWithMeta.meta.metaTags
    .map((tagDef) => {
      const tag = document.createElement("meta");

      Object.keys(tagDef).forEach((key) => {
        tag.setAttribute(key, tagDef[key]);
      });

      // We use this to track which meta tags we create so we don't interfere with other ones.
      tag.setAttribute("data-vue-router-controlled", "");

      return tag;
    })
    // Add the meta tags to the document head.
    .forEach((tag) => document.head.appendChild(tag));

  next();
});

export default router;
